var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.345415 10.273V17.8568L7.00572 11.1965C7.8044 10.3976 8.25307 9.31437 8.25307 8.18486V0.60099L1.59276 7.26144C0.794087 8.06011 0.345415 9.14338 0.345415 10.273Z",
    fill: "#000030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLeaf);
export default __webpack_public_path__ + "static/media/small_leaf.1bbff1c628fe619f427073a550a2dea6.svg";
export { ForwardRef as ReactComponent };